import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DbaRoute } from '@definitiv-packages/angular-dba-library';
import { masterDataRoutes } from '@definitiv-packages/angular-master-data-library';
import { formsRoutes } from '@definitiv-packages/angular-forms-library';

import { StartViewComponent } from './views/start-view/start-view.component';
import { AGBViewComponent } from './views/agb-view/agb-view.component';
import { ImpressumViewComponent } from './views/impressum-view/impressum-view.component';
import { DatenschutzViewComponent } from './views/datenschutz-view/datenschutz-view.component';
import { DebitorMainViewComponent } from './views/debitor-main-view/debitor-main-view.component';
import { ObjektMainViewComponent } from './views/objekt-main-view/objekt-main-view.component';
import { RoofareaMainViewComponent } from './views/roofarea-main-view/roofarea-main-view.component';
import { VerwaltungMainViewComponent } from './views/verwaltung-main-view/verwaltung-main-view.component';
import { UserMainViewComponent } from './views/user-main-view/user-main-view.component';
import { GroupMainViewComponent } from './views/group-main-view/group-main-view.component';
import { SafetyPointMainViewComponent } from './views/safetypoint-main-view/safetypoint-main-view.component';
import { CalendarViewComponent } from './views/calendar-view/calendar-view.component';
import { ServiceMainViewComponent } from './views/service-main-view/service-main-view.component';
import { UuidViewComponent } from './views/uuid-view/uuid-view.component';
import { TodosViewComponent } from './views/todos-view/todos-view.component';
import { StandortMainViewComponent } from './views/standort-main-view/standort-main-view.component';
import { SicherungssystemMainViewComponent } from './views/sicherungssystem-main-view/sicherungssystem-main-view.component';

var routes: DbaRoute<void>[] = [
  { path: '', component: StartViewComponent, title: "itdoc" },

  { path: 'agb', component: AGBViewComponent, title: "AGB" },
  { path: 'impressum', component: ImpressumViewComponent, title: "Impressum" },
  { path: 'datenschutz', component: DatenschutzViewComponent, title: "Datenschutz" },

  { path: 'calendar', component: CalendarViewComponent, title: "calendar" },

  { path: 'debitor', component: DebitorMainViewComponent, title: "debitor" },
  { path: 'objekt', component: ObjektMainViewComponent, title: "objekt" },
  { path: 'roofarea', component: RoofareaMainViewComponent, title: "roofarea" },
  { path: 'safetypoint', component: SafetyPointMainViewComponent, title: "safetypoint" },
  { path: 'service', component: ServiceMainViewComponent, title: "service" },

  { path: 'verwaltung', component: VerwaltungMainViewComponent, title: "Verwaltung" },
  { path: 'userMain', component: UserMainViewComponent, title: "Benutzerverwaltung" },
  { path: 'groupMain', component: GroupMainViewComponent, title: "Gruppenverwaltung" },
  { path: 'uuids', component: UuidViewComponent, title: "ElectronicID" },
  { path: 'todos', component: TodosViewComponent, title: "Todos" },
  { path: 'todos/:todoId', component: TodosViewComponent, title: "Todos" },
  { path: 'standort', component: StandortMainViewComponent, title: "Standort" },
  { path: 'sicherungssystem', component: SicherungssystemMainViewComponent, title: "Sicherungssystem" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    RouterModule.forChild(masterDataRoutes),
    RouterModule.forChild(formsRoutes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
